<div class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
    <form [formGroup]="documentForm" (ngSubmit)="onSave()">
            <h1 class="heading">
               Add
            </h1>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <div>
            <h2 class="heading">
                General Information
            </h2>
            <p class="text-sm-light">
                (Read Only)
            </p>
        </div>
        <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="grid gap-4 md:grid-cols-2">
            <div class="space-y-1">
                <label class="subheading">
                    Docoument Name
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="name" type="text" value=""/>
                    </div> 
                    <div *ngIf="form.name.errors && submitted">
                        <div *ngIf="form.name.errors.required" class="error">
                          <p class="mt-2 text-xs text-main-danger">
                            Name is required
                          </p>
                        </div>
                      </div>
                    <!-- <div class="flex gap-1">
                        <button class="btn btn-danger px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button class="btn-outline btn-outline-success opacity-50 px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div> -->
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    KEY
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <input formControlName="key" type="text" value="" />
                    </div>
                    <div *ngIf="form.key.errors && submitted">
                        <div *ngIf="form.key.errors.required" class="error">
                          <p class="mt-2 text-xs text-main-danger">
                            key is required
                          </p>
                        </div>
                      </div>
                    <!-- <div class="flex gap-1">
                        <button class="btn-outline btn-outline-danger opacity-50 px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button class="btn btn-success px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div> -->
                </div>
            </div>
            <div class="space-y-1">
                <label class="subheading">
                    Type
                </label>
                <div class="flex flex-1 gap-2">
                    <div class="flex-1">
                        <select formControlName="type" name="" id="">
                            <option value="">Select Type</option>
                            <option value="license">license</option>
                        </select>
                    </div>
                    <!-- <div class="flex gap-1">
                        <button class="btn-outline btn-outline-danger px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path
                                    d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                            </svg>
                        </button>
                        <button class="btn-outline btn-outline-success px-2" type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                class="size-5">
                                <path fill-rule="evenodd"
                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div> -->
                </div>
            </div>
        </section>
        <hr class="my-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
        <section class="flex justify-end gap-4">
            <!-- <button class="btn-outline btn-outline-secondary">
                Approve
            </button> -->
            <button type="submit" class="btn btn-secondary">
               {{docId ? 'Update' : 'Save'}}
            </button>
        </section>
    </form>
</div>